import config from "@/config/baseUrl.js"
import { bus } from "@/utils/util.js";
import { tokenStore } from "@/store/modules/tokenUse.js"
import { HubConnectionBuilder } from "@microsoft/signalr";
import { sendMessage } from "@/api/user.js"
import dayjs from "dayjs";

class Signalr {
    constructor() {
        this.connStatus = false;
    }
    /**
     * 开始连接
     */
    async start() {
        try {
            const { getToken } = tokenStore();
            this.client = new HubConnectionBuilder()
                .withUrl(config.baseURL + "/hubs/myhub", { accessTokenFactory: getToken })
                .build();
            await this.client.start();
            this.client.on("ReciveMessage", this.reciveMessage);
            this.client.onclose(this.onclose);
            this.connStatus = true;
        } catch (err) {
            throw err;
        }
    }
    /**
     * 监听连接关闭
     */
    onclose() {
        this.connStatus = false;
        sendMessage().then(() => {
            // 延迟200ms，等待服务器完全启动
            const timeout = setTimeout(() => {
                this.start()
                clearTimeout(timeout);
            }, 200);
        })
    }
    /**
     * 发送消息
     * @param {Number} type 参考[接收消息]的type值
     * @param {String} datetime 接口上一次刷新时间
     * @param {Object} data 传递数据
     */
    async send(type, datetime, data = {}) {
        try {
            if (!this.connStatus) throw "signalr未连接";
            await this.client.send("SendMessage", {
                type,
                data: {
                    datetime: dayjs(datetime).format("MM-DD-YYYY HH:mm:ss"),
                    ...data
                }
            });
        } catch (err) {
            throw err;
        }
    }
    /**
     * 接收消息
     * @param {Object} msg
     * @param {String} msg.type
     * 1: 门诊作业;
     * 2: 门诊收费;
     * 3: 门诊发药;
     * 4: 输注执行;
     * 5: 检验签收
     * 6：检验报告
     * 7：检查报告
     * @param {any} msg.data 服务端返回的数据
     */
    reciveMessage(msg) {
        const { type, data } = JSON.parse(msg);
        switch (type) {
            case "1":
                bus.emit("writeSignalr", data);
                break;
            case "2":
                bus.emit("collectfeeSignalr", data);
                break;
            case "3":
                bus.emit("dispenseSignalr", data);
                break;
            case "4":
                bus.emit("injectionSignalr", data);
                break;
            case "5":
                bus.emit("signInSignalr", data);
                break;
            case "6":
                bus.emit("inspectReportSignalr", data);
                break;
            case "7":
                bus.emit("examineSignalr", data);
                break;
        }
    }
    // 定时器调用时间
    getIntervalTime = () => 1 * 1000;
}

export default Signalr;